export const OPEN_LOGIN = 'OPEN_LOGIN'
export const SHOW_SIGNUP = 'SHOW_SIGNUP'



// WEBPACK FOOTER //
// ./react/school-trigger/constants/action-types.js